import React, { useEffect, useState } from 'react';
import { publicApi } from '../../services/api';
import { flattenSettings, getThemeColors } from '../../utils/settings';

export default function CTASection({ content }) {
  const { title, subtitle, cta_text, cta_link, background_color } = content || {};
  const [theme, setTheme] = useState({ primary: '#081626', secondary: '#00CFFF' });

  useEffect(() => {
    publicApi.getSettings()
      .then(res => {
        const flat = flattenSettings(res.data?.data || {});
        setTheme(getThemeColors(flat));
      })
      .catch(() => {});
  }, []);

  return (
    <section className="py-20 relative overflow-hidden" style={{ background: background_color || `linear-gradient(135deg, ${theme.primary}, ${theme.secondary})` }}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-white rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full blur-3xl" style={{ backgroundColor: theme.secondary }} />
      </div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">
          {title || 'Siap Beralih ke Pembersih Alami?'}
        </h2>
        <p className="text-lg mb-8 max-w-2xl mx-auto" style={{ color: 'rgba(255,255,255,0.85)' }}>
          {subtitle || 'Dapatkan produk Klinnovac sekarang dan rasakan perbedaannya!'}
        </p>
        <a
          href={cta_link || '#products'}
          className="inline-flex items-center gap-2 bg-white font-bold px-10 py-4 rounded-full hover:bg-brand-light transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 text-lg" style={{ color: theme.primary }}
        >
          {cta_text || 'Beli Sekarang'}
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
          </svg>
        </a>
      </div>
    </section>
  );
}